import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/Store";
import { setupAuthInterceptors } from "./redux/authInterceptor";
import { PersistGate } from "redux-persist/integration/react";
import { FaArrowUp } from "react-icons/fa";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import { OnlineStatusProvider } from "./hooks/useOnlineStatus";
import ErrorBoundary from "./components/utils/ErrorBoundary";

const styles = {
  scrollToTopButton: {
    position: "fixed",
    bottom: "20px",
    left: "20px",
    backgroundColor: "#FF5500",
    borderRadius: "50%",
    padding: "15px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
};

const ScrollTopButton = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {showScrollButton && (
        <div onClick={scrollToTop} style={styles.scrollToTopButton}>
          <FaArrowUp color="#fff" />
        </div>
      )}
    </div>
  );
};

// Renews expired sessions for every call to the API
setupAuthInterceptors(store);

// Rendu final
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <React.StrictMode>
        <OnlineStatusProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </OnlineStatusProvider>
        <TawkMessengerReact
          propertyId="675ab9bcaf5bfec1dbdae41c"
          widgetId="1iet6b2t2"
        />
        <ScrollTopButton />
      </React.StrictMode>
    </PersistGate>
  </Provider>
);

// Pour la mesure des performances
reportWebVitals();
